import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { getDiscountedCategoriesInAbsoluteNumber } from './utils';

const initialState = {
  data: {
    content: [],
    links: [],
    page: {},
  },
  apiError: null,
  isFetching: false,
  filters: {
    sortBy: 'A_TO_Z',
    toDisplay: 'ALL',
  },
};

const fetchCategoriesStatsRequest = state => ({
  ...state,
  isFetching: true,
  apiError: null,
});

const fetchCategoriesStatsSuccess = (state, { data }) => ({
  ...state,
  data: {
    ...data,
    content: getDiscountedCategoriesInAbsoluteNumber(data.content),
  },
  isFetching: false,
  apiError: null,
});

const fetchCategoriesStatsFailure = (state, { error }) => ({
  ...state,
  isFetching: false,
  apiError: error,
});

const addFiltersCategoriesStats = (state, { payload }) => ({
  ...state,
  filters: { ...state.filters, ...payload },
});

export default createReducer(initialState, {
  [types.FETCH_CATEGORIES_STATS_REVENUE_REQUEST]: fetchCategoriesStatsRequest,
  [types.FETCH_CATEGORIES_STATS_REVENUE_SUCCESS]: fetchCategoriesStatsSuccess,
  [types.FETCH_CATEGORIES_STATS_REVENUE_FAILURE]: fetchCategoriesStatsFailure,
  [types.ADD_FILTERS_CATEGORIES_STATS_REVENUE]: addFiltersCategoriesStats,
});
